import { CreatedFilters } from "@/services/filters/filters";
import { IFilter } from "@/types";
import { filterClass } from "@/services/filters/filterClass";
import { getActiveUserSearch } from "@/api/user";
import { getAdvertisersSearch, getLegalEntitySearch, getAllContractors, getEUAccountsList } from "@/api/revenue";
import { translateEUAccountStatus, translateStatisticsStatus } from "@/utils/translate";
import { getLastDayOfCurrentMonth, getPreviousMonth } from "@/utils/formatDates";
import { PROJECTS } from '@/services/advertiser/Advertiser';

export class EUAccountsFilters extends CreatedFilters {
    constructor() {
        super();
    }

    getFilters(): IFilter[] {
        const periodValue = [getPreviousMonth('yyyy-MM-dd', 1), getLastDayOfCurrentMonth()];

        return [
            new filterClass.Autocomplete({
                col: 1,
                id: 'id',
                label: 'ID счёта',
                apiMethod: getEUAccountsList,
                itemValue: 'id',
                itemText: 'name',
                template: (i) => i.id,
                select: [],
                items: [],
                defaultValue: [],
                type: 'string',
                key: 'id',
            }),
            new filterClass.Datepicker({
                col: 1,
                id: 'period',
                label: 'Период',
                pickerType: 'month',
                isMonthPicker: true,
                range: true,
                select: periodValue,
                defaultValue: periodValue,
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'currency',
                label: 'Валюта',
                isCurrencyCatalogue: true,
                select: [],
                multiple: true,
                itemValue: 'code',
                itemText: 'code',
                type: 'string',
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'advertiser_id',
                apiMethod: getAdvertisersSearch,
                label: 'Рекламодатель',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
                type: 'number',
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'author',
                apiMethod: getActiveUserSearch,
                label: 'Автор',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                template: (item) => `${item.id} ${item.first_name} ${item.last_name}`,
                multiple: true,
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'account_manager_id',
                apiMethod: getActiveUserSearch,
                label: 'Аккаунт-менеджер',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'project',
                label: 'Проект',
                select: [],
                items: PROJECTS,
                multiple: true,
                itemValue: 'abbr',
                itemText: 'text',
                type: 'string',
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'legal_id',
                apiMethod: getLegalEntitySearch,
                label: 'Наша организация',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
                template: (i) => i.name,
                type: 'number',
            }),
            new filterClass.Autocomplete({
                col: 1,
                id: 'contractor_id',
                apiMethod: getAllContractors,
                label: 'Контрагент',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
                template: (item: any): string => `${item.name}`,
                key: 'query',
                menuProps: {
                    auto: true,
                },
            }),
            new filterClass.Multiselect({
                col: 1,
                id: 'status',
                label: 'Статус',
                items: [
                    { id: 'new' },
                    { id: 'sent_to_1c' },
                    { id: 'awaiting_payment' },
                    { id: 'partially_paid' },
                    { id: 'paid' },
                ],
                type: 'string',
                select: [],
                template: (i) => this.translateStatus(i.id, translateEUAccountStatus),
                itemText: (i) => this.translateStatus(i.id, translateEUAccountStatus),
                itemValue: 'id',
            }),
            new filterClass.Multiselect({
                col: 1,
                id: 'task_status',
                label: 'Статус статистики',
                items: [{ id: 'pending' }, { id: 'in_progress' }, { id: 'done' }],
                type: 'string',
                select: [],
                apiParseUrl: false,
                template: (i) => this.translateStatus(i.id, translateStatisticsStatus),
                itemText: (i) => this.translateStatus(i.id, translateStatisticsStatus),
                itemValue: 'id',
            }),
            new filterClass.Checkbox({
                col: 1,
                label: 'Показать удалённые',
                id: 'show_deleted',
                trueValue: 1,
                falseValue: 0,
                select: 0,
                type: 'string',
            }),
            new filterClass.Checkbox({
                col: 1,
                label: 'Только черновики',
                id: 'is_draft',
                trueValue: 1,
                falseValue: 0,
                select: 0,
                type: 'string',
                dontUseValue: '0',
            }),
            new filterClass.Checkbox({
                col: 1,
                label: 'Есть взаимозачёт',
                id: 'has_netting',
                trueValue: 1,
                falseValue: 0,
                select: 0,
                type: 'string',
                dontUseValue: '0',
            }),
        ];
    }
}
